import classes from './Panel.module.css';
import textClasses from '../Text.module.css';

function Panel(props)
{
    return (
        <div className={classes.panel}>
            <div className={classes.topbar}>
                <div className={`${textClasses.text} ${textClasses.blue} ${textClasses.blink} ${classes.topbarElement}`}>{props.title}</div>
                <div className={`${classes.linkContainer} ${classes.topbarElement}`}>
                    <div className={`${textClasses.text} ${textClasses.link}`}>zeyt8.neocities.org</div>
                </div>
                <div className={`${textClasses.text} ${textClasses.blue} ${classes.topbarElement}`}>[X]</div>
            </div>
            <br/>
            <div className={classes.content}>
                {props.content}
            </div>
        </div>
    );
}

export default Panel;